import React, { Component } from 'react';
import StockRevaluationComp from '../../../components/inventory/importStockRevaluation';
class StockRevaluation extends Component {
	render() {
		return <StockRevaluationComp />;
	}
}

export default StockRevaluation;
